// UnvisitedSiteCardConfig.js
import { MapPin, AlertTriangle, Clock } from "lucide-react";

export const SITE_CARD_CONFIG  = [
  {
    key: "total",
    title: "Total Sites",
    subtitle: "Within last 30 days",
    icon: MapPin,
    bg: "bg-blue-2",
    color: "text-[#2e45a8]",
  },
  {
    key: "critical",
    title: "Critical Sites",
    subtitle: "Not visited >30 days",
    icon: AlertTriangle,
    bg: "bg-red-50",
    color: "text-red-600",
  },
  {
    key: "avg",
    title: "Avg. Days Since Visit",
    subtitle: "Across all unvisited sites",
    icon: Clock,
    bg: "bg-[#e6f4f1]",
    color: "text-[#1a7a6b]",
  },
];